
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import StatusStepper from "./StatusStepper";
import { Clock, CheckCircle2, ShieldCheck } from "lucide-react";

interface ApprovalProcessCardProps {
  agentId: string | undefined;
}

const ApprovalProcessCard: React.FC<ApprovalProcessCardProps> = ({ agentId }) => {
  const navigate = useNavigate();
  
  // Define the approval steps (simplified version)
  const approvalSteps = [
    {
      id: "submitted",
      name: "Submitted",
      description: "Your agent has been successfully submitted",
      completed: true,
      icon: CheckCircle2
    },
    {
      id: "review",
      name: "Under Review",
      description: "Your agent is being reviewed by our team",
      completed: false,
      current: true,
      icon: Clock
    },
    {
      id: "approval",
      name: "Marketplace Ready",
      description: "Once approved, your agent will be available in the marketplace",
      completed: false,
      icon: ShieldCheck
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Approval Process</CardTitle>
        <CardDescription>
          Your agent is currently being processed for marketplace listing
        </CardDescription>
      </CardHeader>
      <CardContent>
        <StatusStepper steps={approvalSteps} />
        
        <div className="mt-8 pt-6 border-t">
          <h3 className="font-medium mb-2">What happens next?</h3>
          <p className="text-muted-foreground mb-4">
            Our team is reviewing your agent to ensure it meets our community guidelines and quality standards.
            This process typically takes 1-2 business days. You'll receive an email notification once your agent is approved.
          </p>
          
          <div className="flex flex-wrap gap-3">
            <Button variant="outline" onClick={() => navigate(`/agent/${agentId}`)}>
              Preview Agent
            </Button>
            
            <Button variant="outline" onClick={() => navigate(`/my-agents`)}>
              View All My Agents
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApprovalProcessCard;
